import React, { useEffect } from "react";
import { useFieldArray, useWatch } from "react-hook-form";
import { TrashIcon } from "@heroicons/react/24/outline";
import classes from "./formDynamicKeyValueList.module.css";

export const FormDynamicKeyValueList = ({
  control,
  register,
  setValue,
  fieldName,
  customClass,
  disabled = false,
  errors = {},
  required = false,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: fieldName,
  });

  const values = useWatch({ control, name: fieldName }) || [];

  // Ensure at least one row exists
  useEffect(() => {
    if (fields.length === 0) {
      setValue(fieldName, [{ name: "", value: "" }], { shouldValidate: false });
    }
  }, [fields, fieldName, setValue]);

  const handleAdd = () => {
    const last = values[values.length - 1];
    if (!last?.name?.trim() || !last?.value?.trim()) return;

    append({ name: "", value: "" });
  };

  const handleRemove = (index) => {
    if (fields.length === 1) return; // always keep at least one row
    remove(index);
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.box}>
        {fields.map((item, index) => {
          const nameError = errors?.[index]?.name;
          const valueError = errors?.[index]?.value;

          return (
            <div
              className={`${classes.row} ${customClass || ""}`}
              key={item.id}
            >
              {/* Name input */}
              <div className={classes.inputBox}>
                <input
                  type="text"
                  className={`${classes.input} ${
                    nameError ? classes.error : ""
                  }`}
                  placeholder=" "
                  disabled={disabled}
                  {...register(`${fieldName}.${index}.name`)}
                />
                <label className={classes.floatingLabel}>
                  Name {required && <span className={classes.asterisk}>*</span>}
                </label>
              </div>

              {/* Value input */}
              <div className={classes.inputBox}>
                <input
                  type="text"
                  className={`${classes.input} ${
                    valueError ? classes.error : ""
                  }`}
                  placeholder=" "
                  disabled={disabled}
                  {...register(`${fieldName}.${index}.value`)}
                />
                <label className={classes.floatingLabel}>
                  Value{" "}
                  {required && <span className={classes.asterisk}>*</span>}
                </label>
              </div>

              {/* Delete button */}
              <button
                type="button"
                className={classes.deleteBtn}
                onClick={() => handleRemove(index)}
                disabled={fields.length === 1 || disabled}
              >
                <TrashIcon className={classes.deleteBtn__img} />
              </button>
            </div>
          );
        })}
      </div>

      {/* Add button */}
      <button
        type="button"
        className={classes.addBtn}
        onClick={handleAdd}
        disabled={disabled}
      >
        Add More
      </button>
    </div>
  );
};
